/**
 * CalendarConfigInventoryMode
 */
export enum CalendarConfigInventoryMode {
    ALL = 'all',
    DENY = 'deny',
    SPECIFIC = 'specific'
}
